export enum Gender {
	Male = 0,
	Female = 1,
	Other = 2,
}

export const GenderNames = {
	[Gender.Male]: 'Male',
	[Gender.Female]: 'Female',
	[Gender.Other]: 'Other',
};
